import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './wpbbsa-calculator-item-v2.component.scss';
var WpbbsaCalculatorItemV2 = /** @class */ (function (_super) {
    tslib_1.__extends(WpbbsaCalculatorItemV2, _super);
    function WpbbsaCalculatorItemV2(element) {
        return _super.call(this, element) || this;
    }
    WpbbsaCalculatorItemV2.prototype.init = function () { };
    WpbbsaCalculatorItemV2.prototype.bindEvents = function () { };
    return WpbbsaCalculatorItemV2;
}(Base));
export { WpbbsaCalculatorItemV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-calculator-item-v2/wpbbsa-calculator-item-v2.component.ts
// module id = 1007
// module chunks = 0